"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _homeTrim = _interopRequireDefault(require("./components/homeTrim.vue"));
var _baseConfig = _interopRequireDefault(require("./components/baseConfig.vue"));
var _SubcommissionAllocation = _interopRequireDefault(require("./components/SubcommissionAllocation"));
var _userCenter = _interopRequireDefault(require("./components/userCenter.vue"));
var _HierarchicalAllocation = _interopRequireDefault(require("./components/HierarchicalAllocation"));
var _appDisposition = _interopRequireDefault(require("./components/appDisposition.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    HomeTrim: _homeTrim.default,
    UserCenter: _userCenter.default,
    SubcommissionAllocation: _SubcommissionAllocation.default,
    BaseConfig: _baseConfig.default,
    HierarchicalAllocation: _HierarchicalAllocation.default,
    appDisposition: _appDisposition.default
  },
  data: function data() {
    return {
      tabList: [{
        name: '首页装修',
        id: '0'
      }, {
        name: '个人中心装修',
        id: '0'
      }, {
        name: '基础设置',
        id: '0'
      }, {
        name: '等级配置',
        id: '0'
      }, {
        name: '区域分佣配置',
        id: '0'
      }, {
        name: 'APP基础配置',
        id: '0'
      }],
      appId: 0,
      activeNum: 0
    };
  },
  computed: {},
  watch: {},
  created: function created() {
    if (this.$route.query.id) {
      console.log(this.$route.query.id);
      this.appId = this.$route.query.id * 1;
    }
  },
  mounted: function mounted() {},
  methods: {
    updateValue: function updateValue(newValue) {
      console.log(newValue, 'heheheheh');
      this.appId = newValue;
    },
    changeType: function changeType(val) {
      this.activeNum = val;
    }
  }
};